import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CareCreditPreapprovedDisclosureBody } from './care-credit-preapproved-disclosure-body';
import { CareCreditPreapprovedDisclosureGenericNavigation } from './navigation/care-credit-preapproved-disclosure-generic-navigation';

export const CareCreditPreapprovedDisclosureNavigationSwitch = () => {
  return (
    <StepNavigationSwitch
      body={CareCreditPreapprovedDisclosureBody}
      generic={CareCreditPreapprovedDisclosureGenericNavigation}
    />
  );
};
